module.exports = __webpack_public_path__ + "img/map_marker_green.bd6dc85a.png";